import * as $ from "jquery";
import { $body } from "../../Core/Body";
import PasswordFields from "../Fields/PasswordFields";

export default class ChangePasswordValidation
{
    readonly Selector: any;

    constructor()
    {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM: '#changePasswordForm'
        }
    }

    public validate()
    {
        let rules = PasswordFields.getFields(this.Selector)

        Object.assign(rules, {
            currentPassword: {
                required: true,
                remote: {
                    url: $(this.Selector.FORM).attr('data-api-url'),
                    type: $(this.Selector.FORM).attr('method'),
                    data: {
                        userId: $(this.Selector.FORM).attr('data-user')
                    }
                }
            }
        });

        $(this.Selector.FORM).validate({
            rules: rules
        });
    }

    public onLoad()
    {
        $body.on( "click", this.validate );
    }

    public onChange()
    {
        $( window ).on( "change", this.validate );
    }
}
import * as $ from "jquery";
import { $body } from "../../Core/Body";
import PasswordFields from "../Fields/PasswordFields";

export default class ChangePasswordValidation
{
    readonly Selector: any;

    constructor()
    {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM: '#changePasswordForm'
        }
    }

    public validate()
    {
        let rules = PasswordFields.getFields(this.Selector)

        Object.assign(rules, {
            currentPassword: {
                required: true,
                remote: {
                    url: $(this.Selector.FORM).attr('data-api-url'),
                    type: $(this.Selector.FORM).attr('method'),
                    data: {
                        userId: $(this.Selector.FORM).attr('data-user')
                    }
                }
            }
        });

        $(this.Selector.FORM).validate({
            rules: rules
        });
    }

    public onLoad()
    {
        $body.on( "click", this.validate );
    }

    public onChange()
    {
        $( window ).on( "change", this.validate );
    }
}
